import { useEffect } from 'react';

export default ({ children }) => {
  useEffect(() => {
    document.title = `Trink Dich Fit: ${children}`;
  }, [children]);

  return null;
};
